import { useEffect } from "react"
import useFeature from "./use-feature"

// Temporary hook to bypass plan comparison component until flipper is fully rolled out
export default function usePlanComparison(showPlanComparison) {
  const { enabled: usePlanComparison } = useFeature(
    "billing_show_newsletter_upgrade_ui"
  )

  useEffect(() => {
    if (!usePlanComparison && showPlanComparison) {
      window.location.href = "/account_settings/billing"
    }
  }, [usePlanComparison, showPlanComparison])

  return usePlanComparison
}
